import React from 'react';
import styled from 'styled-components/macro';
import { AiFillFacebook, AiFillInstagram } from 'react-icons/ai'
import Fade from 'react-reveal/Fade';

const FooterSection = styled.section`
    min-height: 50vh;
    background-color: #3c3c3c;
    position: relative;
    padding: 3rem 4rem;
    box-shadow: 0 -10px 6px rgba(45, 45, 45, .1);
`;

const ContactSection = styled.div`
    margin-bottom: 6rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;

    .contactCard{
        flex: 1 0 100%;

        @media only screen and (min-width: 600px) {
            flex: 0 0 45%;
        }

    a {
        color: #eee;
    }
        
    }
`;

const BusinessContactContainer = styled.div`
    color: #eee;
    padding-top: 4rem;


    .neuCard {
        width: 100%;
        min-height: 5rem;
        box-shadow: -2px -2px 2px #5c5c5c, 2px 2px 2px #1c1c1c;
        padding: 3rem 3.2rem;
        display: flex;
        font-size: 1.4rem;
        position: relative;

        @media only screen and (min-width: 600px) {
            font-size: 1.15rem;
            padding: 2rem ;
        }

        @media only screen and (min-width: 720px) {
            margin: 0 auto;
            font-size: 1.4rem;
            padding: 3rem 3.2rem;
        }

        h3 {
            position: absolute;
            font-size: 1.2rem;
            font-weight: 700;
            letter-spacing: .3rem;
            right: 1rem;
            top: -25%;
            /* transform: translateX(-50%); */
            text-transform: uppercase;
            display: inline-block;
            background-color: #CC14C1;
            padding: 1rem 2rem;

            @media only screen and (min-width: 600px) {
                font-size: 1rem;
                top: -30%;
                right: 1rem;
            }

            @media only screen and (min-width: 900px) {
                font-size: 1.6rem;
                top: -20%;
                right: 1rem;
            }
        }

        .left {
            flex: 1 0 35%;
            text-align: right;
            margin-right: 2rem;

            @media only screen and (min-width: 900px) {
                padding-right: 2rem;
                margin-right: 0;
            }
        }

        .right {
            flex: 1 1 65%;
            margin-left: auto;
        }
    }
`;

const TaglineContainer = styled.div`
    display: flex;
    justify-content: center;

    @media only screen and (min-width: 900px) {
        width: 60%;
        margin: 0 auto;
    }


    .socialMedia {
        /* flex: 1 0 25%; */
        flex: 0 0 15%;
        margin-right: 2rem;
        display: flex;
        flex-wrap: wrap;
        
        @media only screen and (min-width: 440px) {
        }

        a {
            color: #eee;
            font-size: 3rem;
            padding: .5rem;
            display: flex;
            
            @media only screen and (min-width: 440px) {
                align-items: center;
                font-size: 4rem;

                flex: 1 0 100%;
            }

            @media only screen and (min-width: 900px) {
                font-size: 7rem;
                }
            }
        
    }

    .tagline {
        margin-left: auto;
        flex: 1 0 75%;
        display: grid;
        align-items: center;

        @media only screen and (min-width: 440px) {
            flex: 0 0 85%;
            margin-left: 0;
        }
    }

    .icon {
        color: #eee;
        font-size: 2rem;
        padding: .5rem;

        @media only screen and (min-width: 440px) {
            
            font-size: 3.5rem;
        }

        @media only screen and (min-width: 900px) {
            font-size: 5rem;
        }
    }

    a:hover{
        color: #CC14C1;
    }
`;

const Footer = (props) => {
    return (
        <FooterSection>

            <ContactSection id="contact">
                <BusinessContactContainer className="contactCard">
                    <Fade bottom>
                        <div className="neuCard">
                            <h3>Business Hours</h3>
                            <div className="left" style={{textAlign: 'center'}}>
                                <p>All hours are by appointment.</p>
                                <p>Call, text or email to schedule!</p>
                            </div>
                            {/* <div className="right">
                                <p>8:00am - 6:00 pm</p>
                                <p>By appointment</p>
                            </div> */}
                        </div>
                    </Fade>
                </BusinessContactContainer>

                <BusinessContactContainer className="contactCard">
                    <Fade bottom>
                        <div className="neuCard">
                            <h3>Contact</h3>
                            <div className="left">
                                <p>Telephone:</p>
                                <p>Email:</p>
                            </div>
                            <div className="right">
                                <p>(918) 869 - 0869</p>
                                <p><a href="mailto:wizworksllc@gmail.com?subject=WizWorks Contact" target="_blank" rel="noopener noreferrer">wizworksllc@gmail.com</a></p>
                            </div>
                        </div>
                    </Fade>
                </BusinessContactContainer>
            </ContactSection>


            <TaglineContainer>
                <Fade>
                    <div className="socialMedia">
                        {/* <a href="/">
                            <AiFillTwitterCircle />
                        </a> */}
                        <a href="https://www.facebook.com/wizworkscookie/" target="_blank" rel="noopener noreferrer">
                            <AiFillFacebook />
                        </a>
                        <a href="https://www.instagram.com/wizworks_cookie_co/" target="_blank" rel="noopener noreferrer">
                            <AiFillInstagram />
                        </a>
                    </div>
                    <div className="tagline">
                        <svg viewBox="0 0 349 95" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M24.24 35l-1.68-5.28H10.08L8.4 35H0L11.424 1.4h9.792L32.64 35h-8.4zM12.384 22.52h7.872L16.32 10.184 12.384 22.52zM55.185 27.608h12V35h-19.68V1.4h7.68v26.208zM70.567 1.4h7.68V35h-7.68V1.4zM106.581 1.4v7.392h-8.64V35h-7.68V8.792h-8.64V1.4h24.96zM132.503 1.4v7.392h-8.64V35h-7.68V8.792h-8.64V1.4h24.96zM143.544 27.608h12V35h-19.68V1.4h7.68v26.208zM166.607 27.608h13.44V35h-21.12V1.4h20.88v7.392h-13.2v5.568h12v7.296h-12v5.952zM229.98 1.4V35h-7.68V15.464l-8.688 14.256h-.864l-8.688-14.256V35h-7.68V1.4h7.68l9.12 14.928L222.3 1.4h7.68zM257.115 35l-1.68-5.28h-12.48l-1.68 5.28h-8.4l11.424-33.6h9.792L265.515 35h-8.4zm-11.856-12.48h7.872l-3.936-12.336-3.936 12.336zM300.425 16.28v2.88c0 5.024-1.568 9.04-4.704 12.048-3.104 2.976-7.056 4.464-11.856 4.464-5.216 0-9.552-1.68-13.008-5.04-3.424-3.36-5.136-7.488-5.136-12.384s1.696-9.04 5.088-12.432c3.424-3.392 7.6-5.088 12.528-5.088 3.136 0 6 .704 8.592 2.112 2.624 1.408 4.656 3.264 6.096 5.568l-6.528 3.744c-.736-1.152-1.84-2.096-3.312-2.832-1.44-.736-3.072-1.104-4.896-1.104-2.848 0-5.216.944-7.104 2.832-1.856 1.888-2.784 4.304-2.784 7.248 0 2.912.96 5.296 2.88 7.152 1.92 1.824 4.48 2.736 7.68 2.736 4.448 0 7.312-1.728 8.592-5.184h-8.976v-6.72h16.848zM304.755 1.4h7.68V35h-7.68V1.4zM334.24 35.672c-5.024 0-9.2-1.664-12.528-4.992-3.296-3.36-4.944-7.52-4.944-12.48 0-4.96 1.648-9.104 4.944-12.432 3.328-3.36 7.504-5.04 12.528-5.04 3.008 0 5.792.704 8.352 2.112 2.56 1.376 4.576 3.264 6.048 5.664l-6.624 3.84c-.736-1.312-1.792-2.32-3.168-3.024-1.376-.736-2.912-1.104-4.608-1.104-2.976 0-5.36.912-7.152 2.736-1.76 1.824-2.64 4.24-2.64 7.248s.88 5.424 2.64 7.248c1.792 1.824 4.176 2.736 7.152 2.736 1.696 0 3.232-.368 4.608-1.104 1.408-.736 2.464-1.744 3.168-3.024l6.624 3.84c-1.44 2.4-3.44 4.304-6 5.712-2.56 1.376-5.36 2.064-8.4 2.064zM2.88 61.4h7.68V95H2.88V61.4zM35.053 61.4h7.68V95h-5.76l-12.96-18.24V95h-7.68V61.4h5.76l12.96 18.24V61.4zM68.17 87.608h13.44V95H60.49V61.4h20.88v7.392h-13.2v5.568h12v7.296h-12v5.952zM94.007 95L83.061 61.4h8.4l7.44 24.72 7.44-24.72h8.401L103.799 95h-9.793zM125.31 87.608h13.44V95h-21.12V61.4h20.88v7.392h-13.2v5.568h12v7.296h-12v5.952zM160.747 95l-6.336-11.04h-3.648V95h-7.68V61.4h13.44c3.2 0 5.92 1.12 8.16 3.36 2.24 2.24 3.36 4.96 3.36 8.16 0 2.048-.576 3.952-1.728 5.712a11.543 11.543 0 01-4.464 4.032L169.003 95h-8.256zm-9.984-26.4v8.64h5.76c1.056 0 1.952-.416 2.688-1.248.768-.832 1.152-1.856 1.152-3.072s-.384-2.24-1.152-3.072c-.736-.832-1.632-1.248-2.688-1.248h-5.76zM199.037 61.4l-11.28 20.688V95h-7.68V82.088L168.797 61.4h8.736l6.384 12.96 6.384-12.96h8.736zM234.743 77.576c2.752 1.76 4.128 4.288 4.128 7.584 0 2.912-1.04 5.28-3.12 7.104-2.08 1.824-4.656 2.736-7.728 2.736h-14.112V61.4h13.152c3.008 0 5.52.896 7.536 2.688 2.048 1.76 3.072 4.064 3.072 6.912 0 2.688-.976 4.88-2.928 6.576zm-7.68-8.976h-5.472v5.952h5.472c.864 0 1.568-.272 2.112-.816.544-.576.816-1.296.816-2.16 0-.864-.272-1.568-.816-2.112-.544-.576-1.248-.864-2.112-.864zm.96 19.2c.96 0 1.728-.288 2.304-.864.576-.608.864-1.392.864-2.352s-.288-1.728-.864-2.304c-.576-.608-1.344-.912-2.304-.912h-6.432V87.8h6.432zM242.693 61.4h7.679V95h-7.679V61.4zM278.706 61.4v7.392h-8.64V95h-7.68V68.792h-8.64V61.4h24.96zM289.747 87.608h13.441V95h-21.12V61.4h20.88v7.392h-13.201v5.568h12v7.296h-12v5.952z" fill="#eee" /></svg>
                    </div>
                </Fade>
            </TaglineContainer>


        </FooterSection>
    )
}

export default Footer;